<template>
  <v-container>
    <div id="headersTime">
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div
        v-else
      >
        <div
          id="idTable"
          style="overflow-x: auto;"
        >
          <table
            style="width: 100%; color: black; border-collapse: collapse;"
            class="elevation-1"
            mobile-breakpoint="0"
          >
            <thead>
              <tr>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                  @click="mudarOrdenacao('vendedor')"
                >
                  Vendedor
                  <v-icon small>
                    {{ ordenarDados === 'vendedor' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                  </v-icon>
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                  @click="mudarOrdenacao('clienteOrdenacao')"
                >
                  Clientes Ativos
                  <v-icon small>
                    {{ ordenarDados === 'clienteOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                  </v-icon>
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                  @click="mudarOrdenacao('positivadosOrdenacao')"
                >
                  Positivados
                  <v-icon small>
                    {{ ordenarDados === 'positivadosOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                  </v-icon>
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                  @click="mudarOrdenacao('porcentagemOrdenacao')"
                >
                  % Postivação
                  <v-icon small>
                    {{ ordenarDados === 'porcentagemOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                  </v-icon>
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                  @click="mudarOrdenacao('semCompraOrdenacao')"
                >
                  Sem Compra
                  <v-icon small>
                    {{ ordenarDados === 'semCompraOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                  </v-icon>
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                  @click="mudarOrdenacao('ticketOrdenacao')"
                >
                  Ticket Médio
                  <v-icon small>
                    {{ ordenarDados === 'ticketOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                  </v-icon>
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                  @click="mudarOrdenacao('skuOrdenacao')"
                >
                  Cobertura SKU
                  <v-icon small>
                    {{ ordenarDados === 'skuOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                  </v-icon>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in dados"
                :key="item.id"
                :style="item.vendedor === 'Total' ? 'font-weight: bold;' : ''"
              >
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.vendedor }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.cliente }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.positivados }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.porcentagem }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.semCompra }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.ticket }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.sku }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <router-link
          id="linkDetalhe"
          to="/time4/detalhe-analise-vendas"
          class="text-center"
          :style="styleObject"
        >
          <div
            id="linkDetalheAnaliseVendas"
            class="text-center"
          >
            <v-icon
              id="iconLinkAnaliseVendas"
              class="text-center"
            >
              mdi-chevron-double-down
            </v-icon><br>
          </div>
        </router-link>
      </div>
    </div>
  </v-container>
</template>

<script>
  import Time from '../../../../../services/time4'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowFaturamentoVendas',
    emits: ['updateProgressoTime'],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      selectResumo: [],
      selectMes: [],
      selectAno: [],
      selectSupervisor: [],
      receita: [],
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      date: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      supervisor: [],
      segmento: [],
      rede: [],
      categoria: [],
      promotor: [],
      area: [],
      classificacao: [],
      linhaProducao: [],
      dados: [],
      minWidth: 1380,
      width: window.innerWidth,
      enableTable: false,
      ordenarDados: '',
      ordenacaoDadosDecrescente: false,
    }),

    created () {
      eventEmit.$on('update-time', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-time', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, supervisor, receita, segmento, rede, categoria, promotor, area, classificacao, linhaProducao) {
        this.primeiroDia = primeiroDia
        this.date = dataFinal
        this.select = select
        this.supervisor = supervisor
        this.receita = receita
        this.segmento = segmento
        this.rede = rede
        this.categoria = categoria
        this.promotor = promotor
        this.area = area
        this.classificacao = classificacao
        this.linhaProducao = linhaProducao

        this.dados = []
        this.enableTable = false

        localStorage.setItem('supervisorSelect', JSON.stringify(this.supervisor))
        localStorage.setItem('receitaSelect', JSON.stringify(this.receita))
        localStorage.setItem('empresaSelect', this.select)

        this.showTableCoberturaVendedor()
      },

      async showTableCoberturaVendedor () {
        this.loading = true
        this.ordenarDados = ''
        this.ordenacaoDadosDecrescente = false

        await Time.showCoberturaVendedorTime4(this.primeiroDia, this.date, this.select, this.supervisor, this.receita, localStorage.tokencontrato, this.segmento, this.rede, this.categoria, this.promotor, this.area, this.classificacao, this.linhaProducao).then(resposta => {
          if (resposta.data.status) {
            this.enableTable = true

            this.dados = resposta.data.dados.map((item) => {
              var listaMelhoresClientes = ({
                vendedor: item.vendedor,
                cliente: item.cliente.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
                clienteOrdenacao: item.cliente,
                positivados: item.positivados.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
                positivadosOrdenacao: item.positivados,
                porcentagem: item.porcentagem.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
                porcentagemOrdenacao: item.porcentagem,
                semCompra: item.semCompra.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
                semCompraOrdenacao: item.semCompra,
                ticket: item.ticket.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                ticketOrdenacao: item.ticket,
                sku: item.sku.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
                skuOrdenacao: item.sku,
              })

              return listaMelhoresClientes
            })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.enableTable = false

            this.dados = []

            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = 'Network Error'
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          eventEmit.$emit('enable-btn-print', true)

          this.loading = false
        })
      },

      mudarOrdenacao (campo) {
        if (this.ordenarDados === campo) {
          this.ordenacaoDadosDecrescente = !this.ordenacaoDadosDecrescente
        } else {
          this.ordenarDados = campo
          this.ordenacaoDadosDecrescente = false
        }

        this.buscarDadosOrdenados()
      },

      buscarDadosOrdenados () {
        const novaOrdenacao = [...this.dados]

        const totalItem = novaOrdenacao.filter(item => item.vendedor === 'Total')

        const dadosSemTotal = novaOrdenacao.filter(item => item.vendedor !== 'Total')

        dadosSemTotal.sort((a, b) => {
          let result = 0

          if (a[this.ordenarDados] < b[this.ordenarDados]) result = -1
          if (a[this.ordenarDados] > b[this.ordenarDados]) result = 1

          if (this.ordenacaoDadosDecrescente) result *= -1

          return result
        })

        this.dados = totalItem ? [...dadosSemTotal, ...totalItem] : dadosSemTotal
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #headersTime {
      font-size: 9px;
      width: 100% !important;
    }

    #idTable {
      max-height: 500px;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 680px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #headersTime {
      font-size: 9px;
      max-width: 100%;
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

  #dadoMovimentacao {
    font-size: 12px;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }
</style>

<style lang="sass">
  #headersTime
    font-size: 9px

  .tr-min
    display:none

</style>
